(() => {
  const normalizeDate = (date) => new Date(date.getFullYear(), date.getMonth(), date.getDate(), 12);

  const addBusinessDays = (date, numberOfDays) => {
    const result = normalizeDate(date);
    let added = 0;

    while (added < numberOfDays) {
      result.setDate(result.getDate() + 1);
      const day = result.getDay();
      if (day !== 0 && day !== 6) added += 1;
    }

    return result;
  };

  const addCalendarDays = (date, numberOfDays) => {
    const result = normalizeDate(date);
    result.setDate(result.getDate() + numberOfDays);
    return result;
  };

  const getFormatter = (locale, includeYear = false) => {
    try {
      return new Intl.DateTimeFormat(locale || undefined, {
        month: 'short',
        day: 'numeric',
        ...(includeYear ? { year: 'numeric' } : {}),
      });
    } catch (error) {
      return new Intl.DateTimeFormat(undefined, {
        month: 'short',
        day: 'numeric',
        ...(includeYear ? { year: 'numeric' } : {}),
      });
    }
  };

  const initialiseEstimator = (estimator) => {
    const previewDays = Number.parseInt(estimator.dataset.previewBusinessDays, 10) || 3;
    const transitMinDays = Number.parseInt(estimator.dataset.transitMinDays, 10) || 10;
    const transitMaxDays = Math.max(
      transitMinDays,
      Number.parseInt(estimator.dataset.transitMaxDays, 10) || 15
    );
    const locale = estimator.dataset.locale;
    const orderDate = normalizeDate(new Date());
    const previewDate = addBusinessDays(orderDate, previewDays);
    const earliestDate = addCalendarDays(previewDate, transitMinDays);
    const latestDate = addCalendarDays(previewDate, transitMaxDays);
    const includeYear = earliestDate.getFullYear() !== latestDate.getFullYear();
    const formatter = getFormatter(locale, includeYear);
    const orderFormatter = getFormatter(locale, orderDate.getFullYear() !== latestDate.getFullYear());

    const rangeElement = estimator.querySelector('[data-estimate-range]');
    const orderElement = estimator.querySelector('[data-order-date]');
    const previewElement = estimator.querySelector('[data-preview-date]');

    if (rangeElement) {
      rangeElement.textContent = `${formatter.format(earliestDate)} – ${formatter.format(latestDate)}`;
    }
    if (orderElement) orderElement.textContent = orderFormatter.format(orderDate);
    if (previewElement) previewElement.textContent = formatter.format(previewDate);
  };

  const initialiseAll = (root = document) => {
    root.querySelectorAll('[data-delivery-estimator]').forEach(initialiseEstimator);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll());
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();

